import React, { FunctionComponent } from 'react';

const CheckIcon: FunctionComponent = () => (
  <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 6.5L3.375 10L9 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CheckIcon;
